/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * RakeBack Wizard API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query'

import type {
  Account,
  AccountEarningsListParams,
  AccountMigrateCreate400,
  AccountMigrateCreate403,
  ApiPasswordResetConfirmRequest,
  EarningDeal,
  Email,
  EmailChangeConfirm,
  EmailChangeRequest,
  ManualMigration,
  Message,
  PasswordChange,
  PasswordReset,
  PatchedAccount,
  RedemptionStatus,
} from '../models'

import accountRetrieveMutator from '../../client'
import accountUpdateMutator from '../../client'
import accountPartialUpdateMutator from '../../client'
import accountDestroyMutator from '../../client'
import accountEarningsListMutator from '../../client'
import accountEmailChangeCreateMutator from '../../client'
import accountEmailChangeConfirmCreateMutator from '../../client'
import accountEmailVerifyConfirmRetrieveMutator from '../../client'
import accountEmailVerifyResendCreateMutator from '../../client'
import accountMigrateCreateMutator from '../../client'
import accountPasswordChangeCreateMutator from '../../client'
import accountPasswordResetCreateMutator from '../../client'
import accountPasswordResetConfirmCreateMutator from '../../client'
import accountRedemptionStatusRetrieveMutator from '../../client'
import accountRegisterCreateMutator from '../../client'
import accountValidateTokenCreateMutator from '../../client'

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<{ [Q in P]: T[P] }, { -readonly [Q in P]: T[P] }, P>
}[keyof T]

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void
  ? I
  : never
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never

type Writable<T> = Pick<T, WritableKeys<T>>
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object ? NonReadonly<NonNullable<T[P]>> : T[P]
    }
  : DistributeReadOnlyOverUnions<T>

export const accountRetrieve = (signal?: AbortSignal) => {
  return accountRetrieveMutator<Account>({ url: `/api/v1/account/`, method: 'GET', signal })
}

export const getAccountRetrieveQueryKey = () => {
  return [`/api/v1/account/`] as const
}

export const getAccountRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof accountRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof accountRetrieve>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAccountRetrieveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof accountRetrieve>>> = ({ signal }) =>
    accountRetrieve(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof accountRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof accountRetrieve>>>
export type AccountRetrieveQueryError = unknown

export function useAccountRetrieve<
  TData = Awaited<ReturnType<typeof accountRetrieve>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof accountRetrieve>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof accountRetrieve>>,
        TError,
        Awaited<ReturnType<typeof accountRetrieve>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountRetrieve<
  TData = Awaited<ReturnType<typeof accountRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof accountRetrieve>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof accountRetrieve>>,
        TError,
        Awaited<ReturnType<typeof accountRetrieve>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountRetrieve<
  TData = Awaited<ReturnType<typeof accountRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof accountRetrieve>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccountRetrieve<
  TData = Awaited<ReturnType<typeof accountRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof accountRetrieve>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAccountRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getAccountRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof accountRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountRetrieve>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAccountRetrieveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof accountRetrieve>>> = ({ signal }) =>
    accountRetrieve(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof accountRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountRetrieve>>
>
export type AccountRetrieveSuspenseQueryError = unknown

export function useAccountRetrieveSuspense<
  TData = Awaited<ReturnType<typeof accountRetrieve>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountRetrieveSuspense<
  TData = Awaited<ReturnType<typeof accountRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountRetrieveSuspense<
  TData = Awaited<ReturnType<typeof accountRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccountRetrieveSuspense<
  TData = Awaited<ReturnType<typeof accountRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAccountRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const accountUpdate = (account: NonReadonly<Account>) => {
  return accountUpdateMutator<Account>({
    url: `/api/v1/account/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: account,
  })
}

export const getAccountUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountUpdate>>,
    TError,
    { data: NonReadonly<Account> },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountUpdate>>,
  TError,
  { data: NonReadonly<Account> },
  TContext
> => {
  const mutationKey = ['accountUpdate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountUpdate>>,
    { data: NonReadonly<Account> }
  > = (props) => {
    const { data } = props ?? {}

    return accountUpdate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type AccountUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof accountUpdate>>>
export type AccountUpdateMutationBody = NonReadonly<Account>
export type AccountUpdateMutationError = unknown

export const useAccountUpdate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountUpdate>>,
    TError,
    { data: NonReadonly<Account> },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof accountUpdate>>,
  TError,
  { data: NonReadonly<Account> },
  TContext
> => {
  const mutationOptions = getAccountUpdateMutationOptions(options)

  return useMutation(mutationOptions)
}
export const accountPartialUpdate = (patchedAccount: NonReadonly<PatchedAccount>) => {
  return accountPartialUpdateMutator<Account>({
    url: `/api/v1/account/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedAccount,
  })
}

export const getAccountPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountPartialUpdate>>,
    TError,
    { data: NonReadonly<PatchedAccount> },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountPartialUpdate>>,
  TError,
  { data: NonReadonly<PatchedAccount> },
  TContext
> => {
  const mutationKey = ['accountPartialUpdate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountPartialUpdate>>,
    { data: NonReadonly<PatchedAccount> }
  > = (props) => {
    const { data } = props ?? {}

    return accountPartialUpdate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type AccountPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountPartialUpdate>>
>
export type AccountPartialUpdateMutationBody = NonReadonly<PatchedAccount>
export type AccountPartialUpdateMutationError = unknown

export const useAccountPartialUpdate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountPartialUpdate>>,
    TError,
    { data: NonReadonly<PatchedAccount> },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof accountPartialUpdate>>,
  TError,
  { data: NonReadonly<PatchedAccount> },
  TContext
> => {
  const mutationOptions = getAccountPartialUpdateMutationOptions(options)

  return useMutation(mutationOptions)
}
export const accountDestroy = () => {
  return accountDestroyMutator<void>({ url: `/api/v1/account/`, method: 'DELETE' })
}

export const getAccountDestroyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof accountDestroy>>, TError, void, TContext>
}): UseMutationOptions<Awaited<ReturnType<typeof accountDestroy>>, TError, void, TContext> => {
  const mutationKey = ['accountDestroy']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountDestroy>>, void> = () => {
    return accountDestroy()
  }

  return { mutationFn, ...mutationOptions }
}

export type AccountDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof accountDestroy>>>

export type AccountDestroyMutationError = unknown

export const useAccountDestroy = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof accountDestroy>>, TError, void, TContext>
}): UseMutationResult<Awaited<ReturnType<typeof accountDestroy>>, TError, void, TContext> => {
  const mutationOptions = getAccountDestroyMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Fetches a summary of the logged-in user's earnings for all their verified deals for either the current or the previous month.
 * @summary Retrieve Monthly Earnings
 */
export const accountEarningsList = (params: AccountEarningsListParams, signal?: AbortSignal) => {
  return accountEarningsListMutator<EarningDeal[]>({
    url: `/api/v1/account/earnings/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getAccountEarningsListQueryKey = (params: AccountEarningsListParams) => {
  return [`/api/v1/account/earnings/`, ...(params ? [params] : [])] as const
}

export const getAccountEarningsListQueryOptions = <
  TData = Awaited<ReturnType<typeof accountEarningsList>>,
  TError = unknown,
>(
  params: AccountEarningsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof accountEarningsList>>, TError, TData>>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAccountEarningsListQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof accountEarningsList>>> = ({ signal }) =>
    accountEarningsList(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof accountEarningsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountEarningsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountEarningsList>>
>
export type AccountEarningsListQueryError = unknown

export function useAccountEarningsList<
  TData = Awaited<ReturnType<typeof accountEarningsList>>,
  TError = unknown,
>(
  params: AccountEarningsListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accountEarningsList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountEarningsList>>,
          TError,
          Awaited<ReturnType<typeof accountEarningsList>>
        >,
        'initialData'
      >
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountEarningsList<
  TData = Awaited<ReturnType<typeof accountEarningsList>>,
  TError = unknown,
>(
  params: AccountEarningsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accountEarningsList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountEarningsList>>,
          TError,
          Awaited<ReturnType<typeof accountEarningsList>>
        >,
        'initialData'
      >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountEarningsList<
  TData = Awaited<ReturnType<typeof accountEarningsList>>,
  TError = unknown,
>(
  params: AccountEarningsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof accountEarningsList>>, TError, TData>>
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve Monthly Earnings
 */

export function useAccountEarningsList<
  TData = Awaited<ReturnType<typeof accountEarningsList>>,
  TError = unknown,
>(
  params: AccountEarningsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof accountEarningsList>>, TError, TData>>
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAccountEarningsListQueryOptions(params, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getAccountEarningsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof accountEarningsList>>,
  TError = unknown,
>(
  params: AccountEarningsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountEarningsList>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAccountEarningsListQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof accountEarningsList>>> = ({ signal }) =>
    accountEarningsList(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof accountEarningsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountEarningsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountEarningsList>>
>
export type AccountEarningsListSuspenseQueryError = unknown

export function useAccountEarningsListSuspense<
  TData = Awaited<ReturnType<typeof accountEarningsList>>,
  TError = unknown,
>(
  params: AccountEarningsListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountEarningsList>>, TError, TData>
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountEarningsListSuspense<
  TData = Awaited<ReturnType<typeof accountEarningsList>>,
  TError = unknown,
>(
  params: AccountEarningsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountEarningsList>>, TError, TData>
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountEarningsListSuspense<
  TData = Awaited<ReturnType<typeof accountEarningsList>>,
  TError = unknown,
>(
  params: AccountEarningsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountEarningsList>>, TError, TData>
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve Monthly Earnings
 */

export function useAccountEarningsListSuspense<
  TData = Awaited<ReturnType<typeof accountEarningsList>>,
  TError = unknown,
>(
  params: AccountEarningsListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountEarningsList>>, TError, TData>
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAccountEarningsListSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const accountEmailChangeCreate = (
  emailChangeRequest: EmailChangeRequest,
  signal?: AbortSignal,
) => {
  return accountEmailChangeCreateMutator<EmailChangeRequest>({
    url: `/api/v1/account/email/change/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: emailChangeRequest,
    signal,
  })
}

export const getAccountEmailChangeCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountEmailChangeCreate>>,
    TError,
    { data: EmailChangeRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountEmailChangeCreate>>,
  TError,
  { data: EmailChangeRequest },
  TContext
> => {
  const mutationKey = ['accountEmailChangeCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountEmailChangeCreate>>,
    { data: EmailChangeRequest }
  > = (props) => {
    const { data } = props ?? {}

    return accountEmailChangeCreate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type AccountEmailChangeCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountEmailChangeCreate>>
>
export type AccountEmailChangeCreateMutationBody = EmailChangeRequest
export type AccountEmailChangeCreateMutationError = unknown

export const useAccountEmailChangeCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountEmailChangeCreate>>,
    TError,
    { data: EmailChangeRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof accountEmailChangeCreate>>,
  TError,
  { data: EmailChangeRequest },
  TContext
> => {
  const mutationOptions = getAccountEmailChangeCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
export const accountEmailChangeConfirmCreate = (
  emailChangeConfirm: EmailChangeConfirm,
  signal?: AbortSignal,
) => {
  return accountEmailChangeConfirmCreateMutator<EmailChangeConfirm>({
    url: `/api/v1/account/email/change/confirm/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: emailChangeConfirm,
    signal,
  })
}

export const getAccountEmailChangeConfirmCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountEmailChangeConfirmCreate>>,
    TError,
    { data: EmailChangeConfirm },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountEmailChangeConfirmCreate>>,
  TError,
  { data: EmailChangeConfirm },
  TContext
> => {
  const mutationKey = ['accountEmailChangeConfirmCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountEmailChangeConfirmCreate>>,
    { data: EmailChangeConfirm }
  > = (props) => {
    const { data } = props ?? {}

    return accountEmailChangeConfirmCreate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type AccountEmailChangeConfirmCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountEmailChangeConfirmCreate>>
>
export type AccountEmailChangeConfirmCreateMutationBody = EmailChangeConfirm
export type AccountEmailChangeConfirmCreateMutationError = unknown

export const useAccountEmailChangeConfirmCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountEmailChangeConfirmCreate>>,
    TError,
    { data: EmailChangeConfirm },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof accountEmailChangeConfirmCreate>>,
  TError,
  { data: EmailChangeConfirm },
  TContext
> => {
  const mutationOptions = getAccountEmailChangeConfirmCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
export const accountEmailVerifyConfirmRetrieve = (
  uidb64: string,
  token: string,
  signal?: AbortSignal,
) => {
  return accountEmailVerifyConfirmRetrieveMutator<void>({
    url: `/api/v1/account/email/verify/confirm/${uidb64}/${token}/`,
    method: 'GET',
    signal,
  })
}

export const getAccountEmailVerifyConfirmRetrieveQueryKey = (uidb64: string, token: string) => {
  return [`/api/v1/account/email/verify/confirm/${uidb64}/${token}/`] as const
}

export const getAccountEmailVerifyConfirmRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>,
  TError = unknown,
>(
  uidb64: string,
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getAccountEmailVerifyConfirmRetrieveQueryKey(uidb64, token)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>> = ({
    signal,
  }) => accountEmailVerifyConfirmRetrieve(uidb64, token, signal)

  return { queryKey, queryFn, enabled: !!(uidb64 && token), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountEmailVerifyConfirmRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>
>
export type AccountEmailVerifyConfirmRetrieveQueryError = unknown

export function useAccountEmailVerifyConfirmRetrieve<
  TData = Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>,
  TError = unknown,
>(
  uidb64: string,
  token: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>,
          TError,
          Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>
        >,
        'initialData'
      >
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountEmailVerifyConfirmRetrieve<
  TData = Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>,
  TError = unknown,
>(
  uidb64: string,
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>,
          TError,
          Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>
        >,
        'initialData'
      >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountEmailVerifyConfirmRetrieve<
  TData = Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>,
  TError = unknown,
>(
  uidb64: string,
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>, TError, TData>
    >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccountEmailVerifyConfirmRetrieve<
  TData = Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>,
  TError = unknown,
>(
  uidb64: string,
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>, TError, TData>
    >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAccountEmailVerifyConfirmRetrieveQueryOptions(uidb64, token, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getAccountEmailVerifyConfirmRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>,
  TError = unknown,
>(
  uidb64: string,
  token: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>,
        TError,
        TData
      >
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getAccountEmailVerifyConfirmRetrieveQueryKey(uidb64, token)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>> = ({
    signal,
  }) => accountEmailVerifyConfirmRetrieve(uidb64, token, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountEmailVerifyConfirmRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>
>
export type AccountEmailVerifyConfirmRetrieveSuspenseQueryError = unknown

export function useAccountEmailVerifyConfirmRetrieveSuspense<
  TData = Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>,
  TError = unknown,
>(
  uidb64: string,
  token: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>,
        TError,
        TData
      >
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountEmailVerifyConfirmRetrieveSuspense<
  TData = Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>,
  TError = unknown,
>(
  uidb64: string,
  token: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>,
        TError,
        TData
      >
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountEmailVerifyConfirmRetrieveSuspense<
  TData = Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>,
  TError = unknown,
>(
  uidb64: string,
  token: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>,
        TError,
        TData
      >
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccountEmailVerifyConfirmRetrieveSuspense<
  TData = Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>,
  TError = unknown,
>(
  uidb64: string,
  token: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof accountEmailVerifyConfirmRetrieve>>,
        TError,
        TData
      >
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAccountEmailVerifyConfirmRetrieveSuspenseQueryOptions(
    uidb64,
    token,
    options,
  )

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const accountEmailVerifyResendCreate = (email: Email, signal?: AbortSignal) => {
  return accountEmailVerifyResendCreateMutator<Email>({
    url: `/api/v1/account/email/verify/resend/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: email,
    signal,
  })
}

export const getAccountEmailVerifyResendCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountEmailVerifyResendCreate>>,
    TError,
    { data: Email },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountEmailVerifyResendCreate>>,
  TError,
  { data: Email },
  TContext
> => {
  const mutationKey = ['accountEmailVerifyResendCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountEmailVerifyResendCreate>>,
    { data: Email }
  > = (props) => {
    const { data } = props ?? {}

    return accountEmailVerifyResendCreate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type AccountEmailVerifyResendCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountEmailVerifyResendCreate>>
>
export type AccountEmailVerifyResendCreateMutationBody = Email
export type AccountEmailVerifyResendCreateMutationError = unknown

export const useAccountEmailVerifyResendCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountEmailVerifyResendCreate>>,
    TError,
    { data: Email },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof accountEmailVerifyResendCreate>>,
  TError,
  { data: Email },
  TContext
> => {
  const mutationOptions = getAccountEmailVerifyResendCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Allows an authenticated OAuth user to migrate their old email/password account by providing the old credentials. The old account's data will be kept, and the new OAuth credentials will be linked to it.
 * @summary Migrate Email Account to OAuth
 */
export const accountMigrateCreate = (manualMigration: ManualMigration, signal?: AbortSignal) => {
  return accountMigrateCreateMutator<Message>({
    url: `/api/v1/account/migrate/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: manualMigration,
    signal,
  })
}

export const getAccountMigrateCreateMutationOptions = <
  TError = AccountMigrateCreate400 | AccountMigrateCreate403,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountMigrateCreate>>,
    TError,
    { data: ManualMigration },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountMigrateCreate>>,
  TError,
  { data: ManualMigration },
  TContext
> => {
  const mutationKey = ['accountMigrateCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountMigrateCreate>>,
    { data: ManualMigration }
  > = (props) => {
    const { data } = props ?? {}

    return accountMigrateCreate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type AccountMigrateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountMigrateCreate>>
>
export type AccountMigrateCreateMutationBody = ManualMigration
export type AccountMigrateCreateMutationError = AccountMigrateCreate400 | AccountMigrateCreate403

/**
 * @summary Migrate Email Account to OAuth
 */
export const useAccountMigrateCreate = <
  TError = AccountMigrateCreate400 | AccountMigrateCreate403,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountMigrateCreate>>,
    TError,
    { data: ManualMigration },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof accountMigrateCreate>>,
  TError,
  { data: ManualMigration },
  TContext
> => {
  const mutationOptions = getAccountMigrateCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Allows an authenticated user to change their password by providing their current password and a new one.
 * @summary Change User Password
 */
export const accountPasswordChangeCreate = (
  passwordChange: PasswordChange,
  signal?: AbortSignal,
) => {
  return accountPasswordChangeCreateMutator<Message>({
    url: `/api/v1/account/password/change/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: passwordChange,
    signal,
  })
}

export const getAccountPasswordChangeCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountPasswordChangeCreate>>,
    TError,
    { data: PasswordChange },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountPasswordChangeCreate>>,
  TError,
  { data: PasswordChange },
  TContext
> => {
  const mutationKey = ['accountPasswordChangeCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountPasswordChangeCreate>>,
    { data: PasswordChange }
  > = (props) => {
    const { data } = props ?? {}

    return accountPasswordChangeCreate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type AccountPasswordChangeCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountPasswordChangeCreate>>
>
export type AccountPasswordChangeCreateMutationBody = PasswordChange
export type AccountPasswordChangeCreateMutationError = void

/**
 * @summary Change User Password
 */
export const useAccountPasswordChangeCreate = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountPasswordChangeCreate>>,
    TError,
    { data: PasswordChange },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof accountPasswordChangeCreate>>,
  TError,
  { data: PasswordChange },
  TContext
> => {
  const mutationOptions = getAccountPasswordChangeCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
export const accountPasswordResetCreate = (passwordReset: PasswordReset, signal?: AbortSignal) => {
  return accountPasswordResetCreateMutator<PasswordReset>({
    url: `/api/v1/account/password/reset/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: passwordReset,
    signal,
  })
}

export const getAccountPasswordResetCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountPasswordResetCreate>>,
    TError,
    { data: PasswordReset },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountPasswordResetCreate>>,
  TError,
  { data: PasswordReset },
  TContext
> => {
  const mutationKey = ['accountPasswordResetCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountPasswordResetCreate>>,
    { data: PasswordReset }
  > = (props) => {
    const { data } = props ?? {}

    return accountPasswordResetCreate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type AccountPasswordResetCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountPasswordResetCreate>>
>
export type AccountPasswordResetCreateMutationBody = PasswordReset
export type AccountPasswordResetCreateMutationError = unknown

export const useAccountPasswordResetCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountPasswordResetCreate>>,
    TError,
    { data: PasswordReset },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof accountPasswordResetCreate>>,
  TError,
  { data: PasswordReset },
  TContext
> => {
  const mutationOptions = getAccountPasswordResetCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Confirms the password reset by validating uidb64, token and setting the new password.
 * @summary Confirm Password Reset (API)
 */
export const accountPasswordResetConfirmCreate = (
  uidb64: string,
  token: string,
  apiPasswordResetConfirmRequest: ApiPasswordResetConfirmRequest,
  signal?: AbortSignal,
) => {
  return accountPasswordResetConfirmCreateMutator<unknown>({
    url: `/api/v1/account/password/reset/confirm/${uidb64}/${token}/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: apiPasswordResetConfirmRequest,
    signal,
  })
}

export const getAccountPasswordResetConfirmCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountPasswordResetConfirmCreate>>,
    TError,
    { uidb64: string; token: string; data: ApiPasswordResetConfirmRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountPasswordResetConfirmCreate>>,
  TError,
  { uidb64: string; token: string; data: ApiPasswordResetConfirmRequest },
  TContext
> => {
  const mutationKey = ['accountPasswordResetConfirmCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountPasswordResetConfirmCreate>>,
    { uidb64: string; token: string; data: ApiPasswordResetConfirmRequest }
  > = (props) => {
    const { uidb64, token, data } = props ?? {}

    return accountPasswordResetConfirmCreate(uidb64, token, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type AccountPasswordResetConfirmCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountPasswordResetConfirmCreate>>
>
export type AccountPasswordResetConfirmCreateMutationBody = ApiPasswordResetConfirmRequest
export type AccountPasswordResetConfirmCreateMutationError = unknown

/**
 * @summary Confirm Password Reset (API)
 */
export const useAccountPasswordResetConfirmCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountPasswordResetConfirmCreate>>,
    TError,
    { uidb64: string; token: string; data: ApiPasswordResetConfirmRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof accountPasswordResetConfirmCreate>>,
  TError,
  { uidb64: string; token: string; data: ApiPasswordResetConfirmRequest },
  TContext
> => {
  const mutationOptions = getAccountPasswordResetConfirmCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * API view to get the redemption unlock status for the current user.
 */
export const accountRedemptionStatusRetrieve = (signal?: AbortSignal) => {
  return accountRedemptionStatusRetrieveMutator<RedemptionStatus>({
    url: `/api/v1/account/redemption-status/`,
    method: 'GET',
    signal,
  })
}

export const getAccountRedemptionStatusRetrieveQueryKey = () => {
  return [`/api/v1/account/redemption-status/`] as const
}

export const getAccountRedemptionStatusRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAccountRedemptionStatusRetrieveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>> = ({
    signal,
  }) => accountRedemptionStatusRetrieve(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountRedemptionStatusRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>
>
export type AccountRedemptionStatusRetrieveQueryError = unknown

export function useAccountRedemptionStatusRetrieve<
  TData = Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>,
        TError,
        Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountRedemptionStatusRetrieve<
  TData = Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>,
        TError,
        Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountRedemptionStatusRetrieve<
  TData = Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccountRedemptionStatusRetrieve<
  TData = Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAccountRedemptionStatusRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getAccountRedemptionStatusRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>,
      TError,
      TData
    >
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAccountRedemptionStatusRetrieveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>> = ({
    signal,
  }) => accountRedemptionStatusRetrieve(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountRedemptionStatusRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>
>
export type AccountRedemptionStatusRetrieveSuspenseQueryError = unknown

export function useAccountRedemptionStatusRetrieveSuspense<
  TData = Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountRedemptionStatusRetrieveSuspense<
  TData = Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountRedemptionStatusRetrieveSuspense<
  TData = Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccountRedemptionStatusRetrieveSuspense<
  TData = Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof accountRedemptionStatusRetrieve>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAccountRedemptionStatusRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const accountRegisterCreate = (account: NonReadonly<Account>, signal?: AbortSignal) => {
  return accountRegisterCreateMutator<Account>({
    url: `/api/v1/account/register/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: account,
    signal,
  })
}

export const getAccountRegisterCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountRegisterCreate>>,
    TError,
    { data: NonReadonly<Account> },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountRegisterCreate>>,
  TError,
  { data: NonReadonly<Account> },
  TContext
> => {
  const mutationKey = ['accountRegisterCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountRegisterCreate>>,
    { data: NonReadonly<Account> }
  > = (props) => {
    const { data } = props ?? {}

    return accountRegisterCreate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type AccountRegisterCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountRegisterCreate>>
>
export type AccountRegisterCreateMutationBody = NonReadonly<Account>
export type AccountRegisterCreateMutationError = unknown

export const useAccountRegisterCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountRegisterCreate>>,
    TError,
    { data: NonReadonly<Account> },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof accountRegisterCreate>>,
  TError,
  { data: NonReadonly<Account> },
  TContext
> => {
  const mutationOptions = getAccountRegisterCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
export const accountValidateTokenCreate = (signal?: AbortSignal) => {
  return accountValidateTokenCreateMutator<void>({
    url: `/api/v1/account/validate-token/`,
    method: 'POST',
    signal,
  })
}

export const getAccountValidateTokenCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountValidateTokenCreate>>,
    TError,
    void,
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountValidateTokenCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['accountValidateTokenCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountValidateTokenCreate>>,
    void
  > = () => {
    return accountValidateTokenCreate()
  }

  return { mutationFn, ...mutationOptions }
}

export type AccountValidateTokenCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountValidateTokenCreate>>
>

export type AccountValidateTokenCreateMutationError = unknown

export const useAccountValidateTokenCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountValidateTokenCreate>>,
    TError,
    void,
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof accountValidateTokenCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getAccountValidateTokenCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
